import React, { useEffect, useState } from "react";
import { Button, DatePicker, Input, Select, Switch } from "antd";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import useUserData from "../../../../hooks/useUserData";
import moment from "moment";
import UnitWithInput from "../../../../components/UnitWithInput";
import {
  currentUnits,
  loadUnits,
  pressureUnits,
  temperatureUnits,
} from "../../../../Data/data";
import dayjs from "dayjs";
import { useDate } from "../../../../context/DateContext";

export const AirConditioningGenerator = ({ eng_log_basic_id, _items }) => {
  const user = useUserData();
  const { selectedDate } = useDate();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [suctionPressure, setSuctionPressure] = useState("");
  const [dischargePressure, setDischargePressure] = useState("");
  const [luboilPressure, setLuboilPressure] = useState("");
  const [coolingWaterPressure, setCoolingWaterPressure] = useState("");
  const [coolingWaterInTemperature, setCoolingWaterInTemperature] =
    useState("");
  const [coolingWaterOutTemperature, setCoolingWaterOutTemperature] =
    useState("");
  const [motorCurrent, setMotorCurrent] = useState("");
  const [motorTemperature, setMotorTemperature] = useState("");
  const [checked, setChecked] = useState(false);
  const [update_status, set_Update_Status] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);

  const [logDate, set_LogDate] = useState(null);
  const [suctionPressure_unit, setSuctionPressure_Unit] = useState("");
  const [dischargePressure_unit, setDischargePressure_unit] = useState("");
  const [luboilPressure_unit, setLuboilPressure_unit] = useState("");
  const [coolingWaterPressure_unit, setCoolingWaterPressure_Unit] =
    useState("");
  const [coolingWaterInTemperature_unit, setCoolingWaterInTemperature_Unit] =
    useState("");
  const [coolingWaterOutTemperature_unit, setCoolingWaterOutTemperature_unit] =
    useState("");
  const [motorCurrent_unit, setMotorCurrent_Unit] = useState("");
  const [motorTemperature_unit, setMotorTemperature_Unit] = useState("");
  const [otherParams, setOtherParams] = useState({});

  const parameterConfig = {
    suctionpressure: { label: "Suction Pressure", unitList: pressureUnits },
    dischargepressure: { label: "Discharge Pressure", unitList: pressureUnits },
    luboilpressure: { label: "Luboil Pressure", unitList: pressureUnits },
    coolingwaterpressure: {
      label: "Cooling Water Pressure",
      unitList: pressureUnits,
    },
    coolingwaterintemperature: {
      label: "Cooling Water In Temperature",
      unitList: temperatureUnits,
    },
    coolingwaterouttemperature: {
      label: "Cooling Water Out Temperature",
      unitList: temperatureUnits,
    },
    motorcurrent: { label: "Motor Current", unitList: currentUnits },
    motortemperature: {
      label: "Motor Temperature",
      unitList: temperatureUnits,
    },
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    if (parsedData && _items) {
      if (_items?.id)
        VIEW_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(_items?.id, parsedData);
      const otherParamsData = Array.isArray(_items?.other_parameters)
        ? _items.other_parameters
        : [];
      const initialOtherParams = otherParamsData.reduce((acc, param) => {
        acc[param.name] = { value: "", unit: param.unit || "" };
        return acc;
      }, {});
      setOtherParams(initialOtherParams);
    }
  }, [_items?.id]);

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  const handleOtherParamChange = (name, field, value) => {
    setOtherParams((prev) => ({
      ...prev,
      [name]: { ...prev[name], [field]: value },
    }));
  };

  const ADD_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API = (
    air_conditioning_id,
    air_conditioning_on
  ) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      // Append common data
      FORM_DATA.append("air_conditiong_tittle", "Air Conditioning Generator");
      FORM_DATA.append(
        "date_time_log",
        logDate || moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("air_conditioning_on_off", air_conditioning_on);

      // Append Air Conditioning Parameters
      FORM_DATA.append("air_conditioning_id", Number(air_conditioning_id) || 0);

      // Suction Pressure
      FORM_DATA.append("suction_pressure", Number(suctionPressure) || 0);
      FORM_DATA.append("suction_pressure_unit", suctionPressure_unit || "");

      // Discharge Pressure
      FORM_DATA.append("discharge_pressure", Number(dischargePressure) || 0);
      FORM_DATA.append("discharge_pressure_unit", dischargePressure_unit || "");

      // Lub Oil Pressure
      FORM_DATA.append("lub_oil_pressure", Number(luboilPressure) || 0);
      FORM_DATA.append("lub_oil_pressure_unit", luboilPressure_unit || "");

      // Cooling Water Pressure
      FORM_DATA.append(
        "cooling_water_pressure",
        Number(coolingWaterPressure) || 0
      );
      FORM_DATA.append(
        "cooling_water_pressure_unit",
        coolingWaterPressure_unit || ""
      );

      // Cooling Water In Temperature
      FORM_DATA.append(
        "cooling_water_in_temp",
        Number(coolingWaterInTemperature) || 0
      );
      FORM_DATA.append(
        "cooling_water_in_temp_unit",
        coolingWaterInTemperature_unit || ""
      );

      // Cooling Water Out Temperature
      FORM_DATA.append(
        "cooling_water_out_temp",
        Number(coolingWaterOutTemperature) || 0
      );
      FORM_DATA.append(
        "cooling_water_out_temp_unit",
        coolingWaterOutTemperature_unit || ""
      );

      // Motor Current
      FORM_DATA.append("motor_current", Number(motorCurrent) || 0);
      FORM_DATA.append("motor_current_unit", motorCurrent_unit || "");

      // Motor Temperature
      FORM_DATA.append("motor_temperature", Number(motorTemperature) || 0);
      FORM_DATA.append("motor_temperature_unit", motorTemperature_unit || "");

      // Append other parameters (if any)
      FORM_DATA.append("other_parameters", JSON.stringify(otherParams));

      // Submit the data via POST request
      post(ApiURL.add_auxiliary_machinery_air_conditioning, FORM_DATA).then(
        (res) => {
          if (res?.status === true) {
            set_loader(false);
            SuccessToast(
              "Logbook Add Success!",
              "Logbook Auxiliary Machinery details have been successfully added!"
            );
            VIEW_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
              res?.air_conditioning_data?.air_conditioning_id,
              staff_dashboard
            );
          } else {
            set_loader(false);
            const errors = res?.errors || {};
            set_errors(errors);
          }
        }
      );
    } catch (error) {
      console.error("Error in submitting air conditioning data:", error);
      set_loader(false);
    }
  };

  const UPDATE_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API = (
    air_conditioning_id,
    save_submit,
    air_conditioning_on
  ) => {
    set_loader(true); // Show loader while making the API call
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("save_submit", Number(save_submit) || 0);
      FORM_DATA.append(
        "date_time_log",
        logDate || moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("auxi_air_on_off", air_conditioning_on);

      // Append Air Conditioning Parameters
      FORM_DATA.append("air_conditioning_id", Number(air_conditioning_id) || 0);

      // Suction Pressure
      FORM_DATA.append("suction_pressure", Number(suctionPressure) || 0);
      FORM_DATA.append("suction_pressure_unit", suctionPressure_unit || "");

      // Discharge Pressure
      FORM_DATA.append("discharge_pressure", Number(dischargePressure) || 0);
      FORM_DATA.append("discharge_pressure_unit", dischargePressure_unit || "");

      // Lub Oil Pressure
      FORM_DATA.append("lub_oil_pressure", Number(luboilPressure) || 0);
      FORM_DATA.append("lub_oil_pressure_unit", luboilPressure_unit || "");

      // Cooling Water Pressure
      FORM_DATA.append(
        "cooling_water_pressure",
        Number(coolingWaterPressure) || 0
      );
      FORM_DATA.append(
        "cooling_water_pressure_unit",
        coolingWaterPressure_unit || ""
      );

      // Cooling Water In Temperature
      FORM_DATA.append(
        "cooling_water_in_temp",
        Number(coolingWaterInTemperature) || 0
      );
      FORM_DATA.append(
        "cooling_water_in_temp_unit",
        coolingWaterInTemperature_unit || ""
      );

      // Cooling Water Out Temperature
      FORM_DATA.append(
        "cooling_water_out_temp",
        Number(coolingWaterOutTemperature) || 0
      );
      FORM_DATA.append(
        "cooling_water_out_temp_unit",
        coolingWaterOutTemperature_unit || ""
      );

      // Motor Current
      FORM_DATA.append("motor_current", Number(motorCurrent) || 0);
      FORM_DATA.append("motor_current_unit", motorCurrent_unit || "");

      // Motor Temperature
      FORM_DATA.append("motor_temperature", Number(motorTemperature) || 0);
      FORM_DATA.append("motor_temperature_unit", motorTemperature_unit || "");

      // Append other parameters (if any)
      FORM_DATA.append("other_parameters", JSON.stringify(otherParams));

      // Additional parameters (handling merged parameters like in your view API)
      const rawItemParams = _items?.other_parameters || [];
      rawItemParams.forEach((param) => {
        FORM_DATA.append(`other_parameter_${param.name}`, param.value || "");
        FORM_DATA.append(
          `other_parameter_${param.name}_unit`,
          param.unit || ""
        );
      });

      post(
        ApiURL.view_update_auxiliary_machinery_air_conditioning,
        FORM_DATA
      ).then((res) => {
        set_loader(false); // Hide loader once the request is finished

        if (res?.status === true) {
          SuccessToast("Logbook Update Success!", res?.message);
          // Optionally, you could trigger other necessary actions after a successful submission
          if (staff_dashboard) {
            VIEW_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
              res?.air_conditioning_data?.air_conditioning_id,
              staff_dashboard
            );
          }
        } else {
          ErrorToast(
            "Error message",
            "Submission failed! Please fill in all required fields and try again."
          );
          set_errors(res?.errors || {});
        }
      });
    } catch (error) {
      set_loader(false); // Hide loader on error
      console.error("Error Updating logbook:", error);
    }
  };

  const VIEW_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API = async (
    air_conditioning_id,
    voyage_id
  ) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("air_conditioning_id", Number(air_conditioning_id) || 0);
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("voyage_id", voyage_id?.voyage_details?.[0]?.id);

      set_loader(true); // Show loader while fetching data

      post(
        ApiURL.view_update_auxiliary_machinery_air_conditioning,
        FORM_DATA
      ).then((res) => {
        set_loader(false); // Hide loader once data is fetched

        const machinery_Data = res?.air_conditioning_data; // Assuming fresh water machinery data in this format
        if (res?.status === true) {
          // Set common state
          set_Update_Status(machinery_Data?.complete_status);
          setSubmitStatus(res?.submit_status);
          setChecked(machinery_Data?.auxi_air_on_off);
          set_LogDate(
            machinery_Data?.date_time_log ||
              moment().format("YYYY-MM-DD HH:mm:ss")
          );

          // Set machinery-specific parameters (using new state variables)
          setSuctionPressure(machinery_Data?.suction_pressure || "");
          setDischargePressure(machinery_Data?.discharge_pressure || "");
          setLuboilPressure(machinery_Data?.lub_oil_pressure || "");
          setCoolingWaterPressure(machinery_Data?.cooling_water_pressure || "");
          setCoolingWaterInTemperature(
            machinery_Data?.cooling_water_in_temp || ""
          );
          setCoolingWaterOutTemperature(
            machinery_Data?.cooling_water_out_temp || ""
          );
          setMotorCurrent(machinery_Data?.motor_current || "");
          setMotorTemperature(machinery_Data?.motor_temperature || "");

          // Set units for machinery parameters
          setSuctionPressure_Unit(machinery_Data?.suction_pressure_unit || "");
          setDischargePressure_unit(
            machinery_Data?.discharge_pressure_unit || ""
          );
          setLuboilPressure_unit(machinery_Data?.lub_oil_pressure_unit || "");
          setCoolingWaterPressure_Unit(
            machinery_Data?.cooling_water_pressure_unit || ""
          );
          setCoolingWaterInTemperature_Unit(
            machinery_Data?.cooling_water_in_temp_unit || ""
          );
          setCoolingWaterOutTemperature_unit(
            machinery_Data?.cooling_water_out_temp_unit || ""
          );
          setMotorCurrent_Unit(machinery_Data?.motor_current_unit || "");
          setMotorTemperature_Unit(
            machinery_Data?.motor_temperature_unit || ""
          );

          // Handle other parameters (merged with _items)
          const rawItemParams = _items?.other_parameters || [];
          const machineryParams = machinery_Data?.other_parameters || {};

          // Merge the two datasets (machinery and additional parameters)
          const mergedParams = rawItemParams.map((param) => {
            const paramName = param.name;
            const machineryEntry = machineryParams[paramName] || {};
            return {
              name: paramName,
              unit: param.unit || machineryEntry.unit || "",
              value: machineryEntry.value || "",
            };
          });

          const otherParamsData = Array.isArray(mergedParams)
            ? mergedParams
            : [];
          const initialOtherParams = otherParamsData.reduce((acc, param) => {
            acc[param.name] = {
              value: param.value || "",
              unit: param.unit || "",
            };
            return acc;
          }, {});

          setOtherParams(initialOtherParams);
        } else {
          set_errors(res?.errors || {});
        }
      });
    } catch (error) {
      set_loader(false); // Hide loader on error
      console.error("Error updating logbook:", error);
    }
  };

  const otherParameterUnits = [
    ...new Set(Object.values(otherParams || {}).map((param) => param.unit)),
  ];

  return (
    <>
      <div className="row custom-box">
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinary Make:- {_items?.machinary_make}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinary Model:- {_items?.machinary_model}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinary Name :- {_items?.machinary_name}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinary Id:- {_items?.id}
          </b>
        </div>

        <div className="col-2">
          <Switch
            disabled={submitStatus}
            checked={checked}
            onChange={(value) => {
              setChecked(value);
              if (value || !value) {
                update_status
                  ? UPDATE_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                      _items?.id,
                      "0",
                      value
                    )
                  : ADD_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                      _items?.id,
                      value
                    );
              }
            }}
            checkedChildren="On"
            unCheckedChildren="Off"
            style={{ backgroundColor: checked ? "green" : "red" }}
          />
        </div>
      </div>

      {checked && (
        <>
          {(() => {
            const rows = [];

            // Prepare the list of inputs: Start with Date & Time
            const inputs = [
              {
                type: "dateTime",
                name: "dateTime",
                // value: logDate,
                value: update_status && logDate ? logDate : selectedDate,
              },
            ];

            const selectedParams = _items.selected_parameters || [];

            selectedParams.forEach((param) => {
              const config = parameterConfig[param];
              if (config) {
                const stateMap = {
                  suctionpressure: [suctionPressure, setSuctionPressure],
                  dischargepressure: [dischargePressure, setDischargePressure],
                  luboilpressure: [luboilPressure, setLuboilPressure],
                  coolingwaterpressure: [
                    coolingWaterPressure,
                    setCoolingWaterPressure,
                  ],
                  coolingwaterintemperature: [
                    coolingWaterInTemperature,
                    setCoolingWaterInTemperature,
                  ],
                  coolingwaterouttemperature: [
                    coolingWaterOutTemperature,
                    setCoolingWaterOutTemperature,
                  ],
                  motorcurrent: [motorCurrent, setMotorCurrent],
                  motortemperature: [motorTemperature, setMotorTemperature],
                };

                const [value] = stateMap[param] || [];
                const unitStateMap = {
                  suctionpressure: [
                    suctionPressure_unit,
                    setSuctionPressure_Unit,
                  ],
                  dischargepressure: [
                    dischargePressure_unit,
                    setDischargePressure_unit,
                  ],
                  luboilpressure: [luboilPressure_unit, setLuboilPressure_unit],
                  coolingwaterpressure: [
                    coolingWaterPressure_unit,
                    setCoolingWaterPressure_Unit,
                  ],
                  coolingwaterintemperature: [
                    coolingWaterInTemperature_unit,
                    setCoolingWaterInTemperature_Unit,
                  ],
                  coolingwaterouttemperature: [
                    coolingWaterOutTemperature_unit,
                    setCoolingWaterOutTemperature_unit,
                  ],
                  motorcurrent: [motorCurrent_unit, setMotorCurrent_Unit],
                  motortemperature: [
                    motorTemperature_unit,
                    setMotorTemperature_Unit,
                  ],
                };

                const [unit] = unitStateMap[param] || [];
                inputs.push({
                  type: "selectedParam",
                  name: param,
                  config,
                  value,
                  unit,
                });
              }
            });

            // Render inputs in groups of 3

            for (let i = 0; i < inputs.length; i += 3) {
              const group = inputs.slice(i, i + 3);
              rows.push(
                <div className="row" key={`combined-row-${i}`}>
                  {group.map((input, idx) => (
                    <div
                      className="col-4"
                      key={`${input.type}-${input.name}-${idx}`}
                    >
                      {input.type === "dateTime" ? (
                        <div className="input-box">
                          <label>Date & Time</label>
                          <DatePicker
                            showTime
                            format="YYYY-MM-DD HH:mm:ss"
                            placeholder="Select Date & Time"
                            value={
                              input.value
                                ? dayjs(input.value, "YYYY-MM-DD HH:mm:ss")
                                : null
                            }
                            onChange={onChangeDateTime}
                            style={{ width: "100%" }}
                            // disabled={submitStatus}
                            disabled
                          />
                          {errors.date_time_log && (
                            <p className="error-text">{errors.date_time_log}</p>
                          )}
                        </div>
                      ) : (
                        (() => {
                          const config = input.config;
                          const stateMap = {
                            suctionpressure: [
                              suctionPressure,
                              setSuctionPressure,
                            ],
                            dischargepressure: [
                              dischargePressure,
                              setDischargePressure,
                            ],
                            luboilpressure: [luboilPressure, setLuboilPressure],
                            coolingwaterpressure: [
                              coolingWaterPressure,
                              setCoolingWaterPressure,
                            ],
                            coolingwaterintemperature: [
                              coolingWaterInTemperature,
                              setCoolingWaterInTemperature,
                            ],
                            coolingwaterouttemperature: [
                              coolingWaterOutTemperature,
                              setCoolingWaterOutTemperature,
                            ],
                            motorcurrent: [motorCurrent, setMotorCurrent],
                            motortemperature: [
                              motorTemperature,
                              setMotorTemperature,
                            ],
                          };
                          const [, setValue] = stateMap[input.name] || [];
                          const unitStateMap = {
                            suctionpressure: [
                              suctionPressure_unit,
                              setSuctionPressure_Unit,
                            ],
                            dischargepressure: [
                              dischargePressure_unit,
                              setDischargePressure_unit,
                            ],
                            luboilpressure: [
                              luboilPressure_unit,
                              setLuboilPressure_unit,
                            ],
                            coolingwaterpressure: [
                              coolingWaterPressure_unit,
                              setCoolingWaterPressure_Unit,
                            ],
                            coolingwaterintemperature: [
                              coolingWaterInTemperature_unit,
                              setCoolingWaterInTemperature_Unit,
                            ],
                            coolingwaterouttemperature: [
                              coolingWaterOutTemperature_unit,
                              setCoolingWaterOutTemperature_unit,
                            ],
                            motorcurrent: [
                              motorCurrent_unit,
                              setMotorCurrent_Unit,
                            ],
                            motortemperature: [
                              motorTemperature_unit,
                              setMotorTemperature_Unit,
                            ],
                          };
                          const [, setUnit] = unitStateMap[input.name] || [];
                          const errorKey = `pr_${input.name.replace(
                            /([A-Z])/g,
                            (match) => `_${match.toLowerCase()}`
                          )}`;

                          return config.unitList && config.unitList.length ? (
                            <UnitWithInput
                              label={config.label}
                              value={input.value}
                              onChange={(e) => setValue(e.target.value)}
                              unit={input.unit}
                              onUnitChange={(e) => setUnit(e.target.value)}
                              disabled={submitStatus}
                              error={errors[errorKey]}
                              unitList={config.unitList}
                            />
                          ) : (
                            <div className="input-box">
                              <label>{config.label}</label>
                              <Input
                                disabled={submitStatus}
                                value={input.value}
                                placeholder={config.label}
                                onChange={(e) => setValue(e.target.value)}
                              />
                              {errors?.[errorKey] && (
                                <span style={{ color: "red" }}>
                                  {errors[errorKey]}
                                </span>
                              )}
                            </div>
                          );
                        })()
                      )}
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div
                        className="col-4"
                        key={`empty-combined-${i}-${idx}`}
                      ></div>
                    ))}
                </div>
              );
            }

            return rows;
          })()}

          {(() => {
            const rows = [];
            const otherParamsArray = Object.entries(otherParams || {});
            for (let i = 0; i < otherParamsArray.length; i += 3) {
              const group = otherParamsArray.slice(i, i + 3);
              rows.push(
                <div className="row" key={`other-row-${i}`}>
                  {group.map(([name, { value, unit }]) => (
                    <div className="col-4" key={name}>
                      <UnitWithInput
                        label={name}
                        value={value}
                        onChange={(e) =>
                          handleOtherParamChange(name, "value", e.target.value)
                        }
                        unit={unit}
                        onUnitChange={(e) =>
                          handleOtherParamChange(name, "unit", e.target.value)
                        }
                        disabled={submitStatus}
                        unitList={otherParameterUnits}
                      />
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div
                        className="col-4"
                        key={`empty-other-${i}-${idx}`}
                      ></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}

          <div
            className="row"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginLeft: "5px",
            }}
          >
            {["Chief Engineer"].includes(user?.data?.designation) &&
              eng_log_basic_id && (
                <Button
                  disabled={submitStatus}
                  loading={loader}
                  className="save_btn"
                  style={{ color: "white" }}
                  onClick={() =>
                    update_status
                      ? UPDATE_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                          _items?.id,
                          "1",
                          checked
                        )
                      : ADD_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                          _items?.id,
                          checked
                        )
                  }
                >
                  Submit
                </Button>
              )}
            <Button
              disabled={submitStatus}
              loading={loader}
              className="save_btn"
              style={{ color: "white" }}
              onClick={() =>
                update_status
                  ? UPDATE_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                      _items?.id,

                      "0",
                      checked
                    )
                  : ADD_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                      _items?.id,
                      checked
                    )
              }
            >
              Save
            </Button>
          </div>
        </>
      )}
    </>
  );
};
